import { motion } from "framer-motion";
import { User, Linkedin } from "lucide-react";

const TEAM = [
    {
        name: "Sashikant Kakara",
        role: "CEO & Founder",
        bio:
            "25+ years in strategy, marketing, design, and e-Governance across enterprise and public-sector organizations. Founder-operator with deep exposure to India's institutional and regulatory landscape.",
        badge: "Founding Team",
        linkedin: "https://www.linkedin.com/in/sashikant-kakara-2512b5"
    },
    {
        name: "Jyothi Chettiwar",
        role: "Director",
        bio:
            "5+ years in operations and marketing with a focus on organisational growth and execution in emerging markets. Runs GTM and operating cadence at Carbonis.",
        badge: "Leadership",
        linkedin: ""
    },
    {
        name: "DV",
        role: "Advisor — AI & IT",
        bio:
            "25+ years across AI, IT, ADM, and pre-sales for global technology programmes. Advises Carbonis on the intelligence stack and data architecture.",
        badge: "Advisor",
        linkedin: ""
    }
];

export default function Team() {
    return (
        <section className="relative py-24 lg:py-32 border-t border-navy/10" data-testid="team-section">
            <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-16">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-4 mb-6">
                            <div className="w-10 h-px bg-gold"></div>
                            <span className="font-mono text-[11px] tracking-[0.28em] uppercase text-gold">The Team</span>
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.02em] text-navy">
                            Built by <em className="text-gold not-italic font-light">experienced operators.</em>
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 lg:self-end">
                        <p className="text-navy/60 text-lg leading-relaxed">
                            Carbonis was founded in 2024 and is headquartered in Hyderabad, India. We are an UP/OR/OUT Company — building climate risk infrastructure for banks, regulators, and MSMEs across emerging markets.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-navy/10 border border-navy/10">
                    {TEAM.map((m, i) => (
                        <motion.article
                            key={m.name}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.7, delay: i * 0.08 }}
                            className="group bg-white p-8 lg:p-10 flex flex-col gap-6 hover:bg-paper-50 transition-colors duration-500"
                            data-testid={`team-${m.name.split(' ')[0].toLowerCase()}`}
                        >
                            <div className="flex items-start justify-between">
                                <div className="w-14 h-14 border border-navy/15 flex items-center justify-center group-hover:border-gold transition-colors duration-500">
                                    <User size={20} strokeWidth={1.3} className="text-navy/60 group-hover:text-gold transition-colors duration-500" />
                                </div>
                                <span className="font-mono text-[9px] tracking-[0.28em] uppercase text-gold border border-gold/30 px-3 py-1.5">
                                    {m.badge}
                                </span>
                            </div>
                            <div>
                                <h3 className="font-serif text-3xl md:text-4xl text-navy leading-tight tracking-[-0.01em]">
                                    {m.name}
                                </h3>
                                <div className="mt-2 font-mono text-[10px] tracking-[0.24em] uppercase text-navy/50">
                                    {m.role}
                                </div>
                            </div>
                            <p className="text-navy/60 text-[15px] leading-relaxed">{m.bio}</p>
                            {m.linkedin && (
                                <a
                                    href={m.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-auto inline-flex items-center gap-2 text-[10px] font-mono tracking-[0.22em] uppercase text-navy/50 hover:text-gold transition-colors duration-500 self-start"
                                    data-testid={`team-${m.name.split(' ')[0].toLowerCase()}-linkedin`}
                                >
                                    <Linkedin size={13} strokeWidth={1.6} /> LinkedIn
                                </a>
                            )}
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
